export const calc = (networth: string, equity: string, retirement: string, liability: string) => {
  if (networth === "") { networth = "0"; }
  if (equity === "") { equity = "0"; }
  if (retirement === "") { retirement = "0"; }
  if (liability === "") { liability = "0"; }
  const asset: number = parseInt(networth);
  const debt: number = parseInt(equity) + parseInt(retirement) + parseInt(liability);

  let calc: number = asset - debt;

  if (calc % 1000000 !== 0 ){
    calc = Math.floor(calc / 1000000);
    calc = (calc + 1) * 1000000;
  }

  var total = Math.round(calc);

  return total;
}
